import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2363dada&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=2363dada&prod&lang=scss&scoped=true"
import style1 from "./Header.vue?vue&type=style&index=1&id=2363dada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ed9f305f602f0091cce614e7c2faee7e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363dada",
  null
  
)

export default component.exports